export interface ILocality {
  address: string;
  city: string;
  country: string;
  district: string;
  state: string;
  zipcode: string;
}

export enum EMeasureUnit {
  KG = 'KG',
  T = 'T',
  PC = 'PC',
  CX = 'CX'
}

export interface ILocality2 extends ILocality {
  // @TODO: Thiago - verificar se é possível padronizar o retorno de zipcode. No retorno de customers é com camel case, no retorno da creditLimit não
  zipCode: string;
}

export enum EGTMTags {
  //  MEUS PEDIDOS
  CONSULTA_PEDIDOS_ABERTOS = 'gtm-busca-pedidos-abertos', // Botão de busca de Pedidos em aberto
  CONSULTA_PEDIDOS_FATURADOS = 'gtm-busca-pedidos-faturados', // Botão de busca de Pedidos faturados
  EXPORTAR_PEDIDOS_ABERTOS = 'gtm-exportar-pedidos-abertos', // botão exportar pedidos (quando estiver na aba Abertos)
  EXPORTAR_PEDIDOS_FATURADOS = 'gtm-exportar-pedidos-faturados', // botão exportar pedidos (quando estiver na aba Faturados )
  DOWNLOAD_CQ = 'gtm-baixar-certificado-qualidade', // clicar em download CQ na tabela
  DOWNLOAD_NF = 'gtm-baixar-nota-fiscal', // baixar NF na tabela de meus pedidos faturados

  // MINHAS FINANÇAS
  DETALHES_LIMITE_CREDITO = 'gtm-detalhes-limite-crédito', // ID - botão detalhes de crédito
  EXPORTAR_DUPLICATAS = 'gtm-exportar-duplicatas', // exportar duplicatas
  SEGUNDA_VIA_BOLETO = 'gtm-segunda-via-boleto', // clicar em download boleto na tabela
  CONSULTA_DUPLICATAS = 'gtm-busca-duplicatas', // Botão de busca de Finanças
  DETALHES_CREDITO = 'gtm-detalhes-creditos-compensar', // clicar em detalhes em floatBar de Finanças
  DOWNLOAD_NF_FINANCAS = 'gtm-baixar-nota-fiscal-financas', // baixar NF na tabela de finanças

  // COMPRAR
  REPETIR_ULTIMO_PEDIDO = 'gtm-repetir-ultimo-pedido', // botão de repetir último pedido
  INSERIR_ITENS = 'gtm-inserir-itens', // Botão de inserir itens via sku ou descrição
  INSERIR_VIA_PLANILHA = 'gtm-pedido-planilha', // ao clicar no botão de inserir via planilha em ENTRY-TYPE
  CONFIRMAR_CONFIG_PLANILHA = 'gtm-confirmar-config-planilha', // ao clicar em avançar em SpreadsheetConfigModal
  ADICIONAR_PLANILHA = 'gtm-upload-planilha', // botão de adicionar planilha
  AVANCAR_REVISAR_PEDIDO = 'gtm-avancar-revisar-pedido', // Botão de "Avançar" na tela de configurar o pedido
  CONFIRMAR_PEDIDO = 'gtm-confirmar-pedido', // Botão de confirmar pedido na tela de checkout

  // MAQUETES E PROJETOS C&D
  ADICIONAR_PROJETO = 'gtm-upload-projeto', // botão de adicionar arquivo projeto
  DOWNLOAD_PROJETO = 'gtm-baixar-projeto' // baixar NF na tabela
}
